import JSZip from 'jszip';
import { saveAs } from 'file-saver';
export const combineArrays = (...arrays) => {
    const minLength = Math.min(...arrays.map((arr) => arr.length));

    return Array.from({ length: minLength }, (_, index) => arrays.map((arr) => arr[index]));
};
export const getHeader = (values) => {
    let header = '';
    values.map((item, index) => {
        if (index !== values.length - 1) {
            header += item.name + ',';
        } else header += item.name;
        return item;
    });
    return 'Time,' + header;
};
export const getCombinedArrayMultilevel = (values) => {
    let multiLevelArray = [];
    values.map((item) => {
        multiLevelArray.push(item.data);
        return values;
    });
    return multiLevelArray;
};
export const getGivenKeyValueFromArrayOfObject = (arrayItems, keyToCheck) => {
    return arrayItems?.map((item) => item[keyToCheck]);
};
export const joinArraysItem = (arrayItems) => {
    return arrayItems?.join(',');
};

export const formatChartData = (chartData) => {
    const headerValues = getHeader(chartData.value);
    const combinedArray = getCombinedArrayMultilevel(chartData.value);
    const timeArray = chartData.xIndex;
    const combineArrayWithSameIndexRow = combineArrays(timeArray, ...combinedArray);
    const data = combineArrayWithSameIndexRow.join('\n');
    return {
        header: headerValues,
        data: data
    };
};

export const formatChartDataV2 = (chartData) => {
    const headerValues = chartData.headers;
    const data = chartData.data.join('\n');
    return {
        header: headerValues,
        data: data
    };
};
export const handleDownloadCSVData = (chartData) => {
    const { header, data } = formatChartData(chartData);
    let csvData = header + '\n' + data;
    let anchor = document.createElement('a');
    anchor.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvData);
    anchor.target = '_blank';
    anchor.download = 'line-chart.csv';
    anchor.click();
};

export const handleDownloadCSVDataV2 = (chartData, fileName) => {
    const { header, data } = formatChartDataV2(chartData);
    let csvData = header + '\n' + data;
    let anchor = document.createElement('a');
    anchor.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvData);
    anchor.target = '_blank';
    anchor.download = `${fileName}.csv`;
    anchor.click();
};

export const getCsvDataWithFileName = (chartData, fileName) => {
    const { header, data } = formatChartDataV2(chartData);
    let csvData = header + '\n' + data;
    return {
        fileName: `${fileName}.csv`,
        csvData: csvData
    };
};

export const handleAndDownloadZipFileForCsv = (csvFile) => {
    const zip = new JSZip();
    const csvFiles = [
        ...csvFile
        // Add more CSV files as needed
    ];

    csvFiles.forEach((file) => {
        zip.file(file.fileName, file.csvData);
    });

    zip.generateAsync({ type: 'blob' }).then((content) => {
        saveAs(content, 'Historical-Chart.zip');
    });
};
